'use strict';

const CSRFUtil = {
    getToken: function() {
        return $('input[name="csrf_token"]').val();
    },

    /**
     * Updates the tokens elements on the page.
     * Creates a new token element if there aren't any.
     * @param {string} newToken 
     */
    updateToken: function(newToken) {
        var $inputs = $('input[name="csrf_token"]');
        if ($inputs.length) {
            $inputs.val(newToken);
        } else {
            $('<input>').attr({
                type: 'hidden',
                name: 'csrf_token',
                value: newToken
            }).appendTo('body');
        }
    },

    /**
     * Gets the token as a string "csrf_token=<token-value>"
     */
    getAsQueryParam: function() {
        return $.param({csrf_token: this.getToken()});
    },

    /**
     * Gets the token as an object with "name" and "value" properties
     */
    getAsObject: function() {
        return {
            name: 'csrf_token',
            value: this.getToken()
        };
    },

    /**
     * Adds the token to serialized forms data
     * @param {Array|string|Object} formData serialized form data
     * @returns {Array} serialized form data array with CSRF token
     */
    addTokenToFormData: function(formData) {
        if (formData instanceof Array) {
            formData.push(this.getAsObject());
        } else if (typeof formData === 'string') {
            formData += `&${this.getAsQueryParam()}`
        } else { // object
            Object.assign(formData, {'csrf_token': this.getToken()});
        }
        return formData;
    },

    /**
     * Refresh the token and updates the existing ones
     */
    refreshToken: function() {
        var endpoint = $('#csrf-refresh-url').val();
        if (! endpoint) return false;

        $.ajax({
            url: endpoint,
            dataType: 'json',
            type: 'POST',
            success: function(data) {
                var csrf_value = data.csrf.token;
                module.exports.updateToken(csrf_value);
            }
        });
    },

    /**
     * Starts automatically refresh the token
     * @param {Number} minutes
     * @returns {Number} the ID of the interval
     */
    startAutoRefresh: function(minutes) {
        return setInterval(function() {
            module.exports.refreshToken();
        }, minutes * 60 * 1000);
    },

    /**
     * Stops automatically refresh the token
     * @param {Number} intervalId the ID of the interval to be stopped
     */
    stopAutoRefresh: function(intervalId) {
        clearInterval(intervalId);
    }
}

module.exports = CSRFUtil;
